import { Injectable, Inject, enableProdMode } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Tenant } from 'src/app/shared/models/tenant';
import { WINDOW } from 'src/app/shared/utils/window.provider';
import { AppConfig } from '../models/config/appConfig';
import { AppConfigService } from './app-config.service';
import { Router } from '@angular/router';
import { AuthClientConfig } from '@auth0/auth0-angular';

@Injectable()
export class AppInitializationService {
  public static readonly EnvironmentSettingsLocation: string = '/assets/config/environment.json';

  constructor(
    private http: HttpClient,
    @Inject(WINDOW) private window: Window,
    private appConfigService: AppConfigService,
    private router: Router,
    private authClientConfig: AuthClientConfig
  ) {
    this.appConfigService.redirectUri = window.location.origin.concat('/callback');
    this.appConfigService.logoutRedirectUri = window.location.origin.concat('/logout');
  }

  get baseApiUrl(): string {
    return this.appConfigService.baseApiUrl;
  }

  load(): Promise<AppConfigService> {
    return this.http
      .get(AppInitializationService.EnvironmentSettingsLocation + '?t=' + new Date().getTime())
      .toPromise()
      .then((res) => {
        this.appConfigService.config = AppConfig.parse(res);
        const authConfig = this.appConfigService.config.auth;
        this.authClientConfig.set({
          domain: authConfig.domain,
          clientId: authConfig.clientId,
          errorPath: '/unsuccessful-login',
          authorizationParams: {
            redirect_uri: this.appConfigService.redirectUri,
            audience: authConfig.audience,
            tokenIssuer: authConfig.tokenIssuer,
            tenant: authConfig.tenant,
            scope: 'openid profile email manage:teams offline_access',
          },
        });
      })
      .then(() => {
        return this.http.get(this.baseApiUrl.concat('tenants/current')).toPromise();
      })
      .then((res) => {
        this.appConfigService.tenant = Tenant.parse(res);
        this.appConfigService.initialized = true;
        this.appConfigService.loadError = false;
        return this.appConfigService;
      })
      .catch((error: any) => {
        this.appConfigService.initialized = false;
        this.appConfigService.loadError = true;
        this.router.navigate(['/maintenance-mode'], { skipLocationChange: true });
        return this.appConfigService;
      });
  }
}
